import { observable } from 'mobx'

export interface IBreakpoints {
  phone: string | boolean
  desktop: string | boolean
  tablet: string | boolean
}

export const breakpoints: IBreakpoints = observable({
  phone: '(max-width: 768px) , (max-height: 480px)',
  desktop: '(min-width: 769px) AND (min-height: 480px))',
  tablet: '(min-width: 768px) AND (max-width: 1440px) AND (min-height: 480px)',
})
